import React from 'react'
import styled from 'styled-components'
import {Box, themeGet} from '../..'
import BoxWithIndicator from './BoxWithIndicator'
import {useCenterY} from './context/VerticalPositionContext'
import {RuleDetailProps} from './types'
/**
 * A RuleDetail renders a containing element that describes the details contained with a rule, and consists of a container and a caret that follows a rule as it progresses through a workflow
 */
export const RuleDetail = ({
  children,
  side = 'left',
  headerHeight = 0,
  hideArrow = false,
  caretTop,
  testId,
  sx: sxProp
}: RuleDetailProps) => {
  const {centerY} = useCenterY()

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const calculatedCaretTop =
    caretTop !== undefined ? caretTop - headerHeight : centerY ? centerY - headerHeight - 16 : 44

  return (
    <BoxWithIndicator side={side} hideArrow={hideArrow} caretTop={calculatedCaretTop} testId={testId} sx={sxProp}>
      {children}
    </BoxWithIndicator>
  )
}

RuleDetail.displayName = 'RuleDetail'
